import productSuitabilities from '../../api/productSuitabilities';

const actions = {
  getProductSuitabilities() {
    return new Promise((resolve, reject) => {
      productSuitabilities
        .getProductSuitabilities()
        .then(() => {
          resolve(true);
        })
        .catch(error => reject(error));
    });
  },
  updateProductSuitability(context, { id, updates }) {
    return new Promise((resolve, reject) => {
      productSuitabilities
        .updateProductSuitability(id, updates)
        .then(() => {
          resolve(true);
        })
        .catch(error => reject(error));
    });
  },
  addProductSuitability(context, { productSuitability }) {
    console.log(productSuitability);
    return new Promise((resolve, reject) => {
      productSuitabilities
        .addProductSuitability(productSuitability)
        .then(() => {
          resolve(true);
        })
        .catch(error => reject(error));
    });
  },
  deleteProductSuitability(context, { productSuitability }) {
    return new Promise((resolve, reject) => {
      productSuitabilities
        .deleteProductSuitability(productSuitability.id)
        .then(() => {
          resolve(true);
        })
        .catch(error => reject(error));
    });
  }
};

export default {
  actions
};
